var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76347 2.46414H8.73008V0.780613C8.56332 0.757672 7.98979 0.706055 7.32186 0.706055C5.92818 0.706055 4.97348 1.58267 4.97348 3.19384V4.67663H3.43555V6.55868H4.97348V11.2943H6.85906V6.55912H8.33479L8.56906 4.67707H6.85862V3.38046C6.85906 2.83649 7.00553 2.46414 7.76347 2.46414Z",
    fill: "#101237"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5882,
    height: 10.5882,
    fill: "white",
    transform: "translate(0.706055 0.705811)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.aa197f1d0f06e0048c7957997ec79492.svg";
export { ForwardRef as ReactComponent };